module.exports = __webpack_public_path__ + "img/location@2x.e03bb731.png";